// dependency-graph-ignore-file
import { FlagsManager } from '../contracts/flags-manager';
import { type AddFlagProps, type Flag } from '../types';

/**
 * A default implementation of the FlagsManager contract.
 * This is designed for use with `<DefaultFlagGroup />`.
 */
export class DefaultFlagsManager extends FlagsManager {
  addFlag(flagProps: AddFlagProps) {
    const newFlagId = this.flags.data.length + 1;
    const newFlag: Flag = {
      id: newFlagId,
      ...flagProps,
    };

    this.flags.data.unshift(newFlag);
  }

  handleFlagDismiss(flagId: number | string) {
    this.flags.data = this.flags.data.filter((flag) => flag.id !== flagId);
  }

  clearFlags() {
    this.flags.data = [];
  }
}
